<template>
  <v-card-title class="header-container">
    <v-layout column align-content-start>
      <img class="header-logo" src="../../../../static/2dsearch-ai/2dSearch-ai-logo.svg" alt="">
      <span class="divider-line divider-line-blue header-divider"></span>
    </v-layout>
  </v-card-title>
</template>

<script>
export default {
  name: 'SearchAIHeader'
}
</script>
<style scoped lang="scss">
.header {
  &-container {
    width: 100%;
    padding: 20px 0 0 0;
    position: sticky;
    top: 0;
    background-color: $bg-primary;
    z-index: 1;
  }
  &-logo {
    height: $font-size-large;
    width: fit-content;
  }
  &-divider {
    width: 100%;
    height: $length-small-m;
    border-radius: $length-small-m;
    margin-top: $length-small-xl;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/searchAi/SearchAIHeader.vue